import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import styles from './recovery-form.module.sass';
import Button from '../ui/button/Button';
import { api } from '../../services/api';
import { useTranslation } from 'react-i18next';

const RecoveryForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [resetingEmail, setResettingEmail] = useState('');

  const resetEmailHandler = (e: any) => {
    e.preventDefault();
    api
      .post('/user/reset-password', { email: resetingEmail })
      .then((response) => {
        if (response.status === 200) {
          navigate('/recovery-alert');
        }
      })
      .catch((error) => console.error(error));
  };

  return (
    <form className={styles.recoveryForm} onSubmit={resetEmailHandler}>
      <h2 className={styles.title}>{t('additionalPages.forgotPassword')}</h2>
      <p>{t('additionalPages.enterEmailToReset')}</p>
      <label>
        <input
          name="email"
          type="email"
          className={styles.emailResetInput}
          placeholder="Email"
          onChange={(evt: any) => setResettingEmail(evt.target.value)}
          value={resetingEmail}
        />
      </label>
      <Button type="submit" variant={'accent'}>
        {t('additionalPages.continue')}
      </Button>
      <button className={styles.returnLink} onClick={() => navigate(-1)}>
        {t('additionalPages.back')}
      </button>
    </form>
  );
};
export default RecoveryForm;
